/**
 * Created by muxo on 02.01.2017.
 */
if (process.env.NODE_ENV === "access" || process.env.NODE_ENV === "test") {
    module.exports = require("./HttpQuery.dummy");
} else {
    module.exports = require("./HttpQuery.work");
}